import React, { useState } from "react";
import CollapseToggle from '../layout/CollapseToggle';
import Spacer from '../layout/Spacer';
import { TooltipKeys } from "../tooltips/TooltipKeys";

/**
 * defines a checkbox input for boolean values
 * @export
 * @param {{
 * value: Boolean,
 * onChangeCallback: (newValue: Boolean),
 * onCommitCallback: (),
 * "data-name": String,
 * title: String,
 * decorators: [<ReactElements>]
 * }} props this property expects and can use these special props:
 * - value: the current value of the header toggle
 * - onChangeCallback: a callback function that will be executed whenever the value of the internal value changes, with the new value as the passed parameter *optional*
 * - onCommitCallback: a callback function that will be executed when the internal field loses focus, passing no parameters *optional*
 * - "data-name": used for automation purposes to specifically identify this property. *defaults to "-header-property". optional*
 * @returns a clickable header that toggles a bool on click
 */
export default function HeaderProperty(props)
{
	const [value, setValue] = useState(props.value ? props.value : false);

	function onClick(e)
	{
		const newValue = !value;
		setValue(newValue);
		if (props.onChangeCallback)
		{
			props.onChangeCallback(newValue);
		}
		if (props.onCommitCallback)
		{
			props.onCommitCallback();
		}
	}

	return (
		<table className={[
			"propertyGroup headerPropertyRoot",
			(props.className ? props.className : ""),
		].join(' ')}
		data-name={props["data-name"] ? props["data-name"] + "-root" : "header-property-" + props.title + "-root"}
		>
			<thead>
				<tr>
					<th className={[
						"propertyGroupHeader",
						(props.headerClassName ? props.headerClassName : ""),
					].join(' ')}
					data-tooltip={TooltipKeys.PropertyGroupHeader}
					onDoubleClick={onClick}
					>
						<CollapseToggle
							isExpanded={value}
							onToggleCallback={onClick}
						/>
						<div className="propertyGroupHeaderText">
							{props.title}
						</div>
						<Spacer stretchTo={{ x: "100%" }} />
						{props.decorators}
					</th>
				</tr>
			</thead>
		</table>
	);
}
